import { AddUser } from '../foundations/icons/avatar/add-user';
import { Group } from '../foundations/icons/avatar/group';
import { LongHair } from '../foundations/icons/avatar/long-hair';
import { ShortHair } from '../foundations/icons/avatar/short-hair';
import { UserSettings } from '../foundations/icons/avatar/user-settings';
import { ArrowLeft } from '../foundations/icons/basic/arrow-left';
import { ArrowRight } from '../foundations/icons/basic/arrow-right';
import { ArrowsLeftRight } from '../foundations/icons/basic/arrows-left-right';
import { CheckmarkCircle } from '../foundations/icons/basic/checkmark-circle';
import { Cycle } from '../foundations/icons/basic/cycle';
import { DollarSign } from '../foundations/icons/basic/dollar-sign';
import { DollarSignCircle } from '../foundations/icons/basic/dollar-sign-circle';
import { Exclamation } from '../foundations/icons/basic/exclamation';
import { Info } from '../foundations/icons/basic/info';
import { InfoCircle } from '../foundations/icons/basic/info-circle';
import { Minus } from '../foundations/icons/basic/minus';
import { New } from '../foundations/icons/basic/new';
import { No } from '../foundations/icons/basic/no';
import { Plus } from '../foundations/icons/basic/plus';
import { QuestionMark } from '../foundations/icons/basic/question-mark';
import { QuestionMarkCircle } from '../foundations/icons/basic/question-mark-circle';
import { Restart } from '../foundations/icons/basic/restart';
import { RestartCircle } from '../foundations/icons/basic/restart-circle';
import { X } from '../foundations/icons/basic/x';
import { Attachment } from '../foundations/icons/content/attachment';
import { Calendar } from '../foundations/icons/content/calendar';
import { CalendarDate } from '../foundations/icons/content/calendar-date';
import { Checklists } from '../foundations/icons/content/checklists';
import { Checkmark } from '../foundations/icons/content/checkmark';
import { ContentShare } from '../foundations/icons/content/content-share';
import { DiagramNetwork } from '../foundations/icons/content/diagram-network';
import { DiagramOrgChart } from '../foundations/icons/content/diagram-org-chart';
import { DiagramVenn } from '../foundations/icons/content/diagram-venn';
import { Email } from '../foundations/icons/content/email';
import { Filter } from '../foundations/icons/content/filter';
import { Folder } from '../foundations/icons/content/folder';
import { GraphBar } from '../foundations/icons/content/graph-bar';
import { GraphLine } from '../foundations/icons/content/graph-line';
import { GraphPie } from '../foundations/icons/content/graph-pie';
import { Hive } from '../foundations/icons/content/hive';
import { Link } from '../foundations/icons/content/link';
import { List } from '../foundations/icons/content/list';
import { Map } from '../foundations/icons/content/map';
import { MapPin } from '../foundations/icons/content/map-pin';
import { Maximize } from '../foundations/icons/content/maximize';
import { Message } from '../foundations/icons/content/message';
import { OrgChart } from '../foundations/icons/content/org-chart';
import { Page } from '../foundations/icons/content/page';
import { PageMultiple } from '../foundations/icons/content/page-multiple';
import { PageRefresh } from '../foundations/icons/content/page-refresh';
import { PageTree } from '../foundations/icons/content/page-tree';
import { Process } from '../foundations/icons/content/process';
import { Rss } from '../foundations/icons/content/rss';
import { SmileyFace } from '../foundations/icons/content/smiley-face';
import { Translate } from '../foundations/icons/content/translate';
import { ZipFile } from '../foundations/icons/content/zip-file';
import { ZoomIn } from '../foundations/icons/content/zoom-in';
import { ZoomOut } from '../foundations/icons/content/zoom-out';
import { Computer } from '../foundations/icons/device/computer';
import { Laptop } from '../foundations/icons/device/laptop';
import { Smartphone } from '../foundations/icons/device/smartphone';
import { TwoFactorAuth } from '../foundations/icons/device/two-factor-auth';
import { Watch } from '../foundations/icons/device/watch';
import { Badge } from '../foundations/icons/object/badge';
import { Ball } from '../foundations/icons/object/ball';
import { Balloon } from '../foundations/icons/object/balloon';
import { Beer } from '../foundations/icons/object/beer';
import { Binoculars } from '../foundations/icons/object/binoculars';
import { Bold } from '../foundations/icons/object/bold';
import { Bomb } from '../foundations/icons/object/bomb';
import { Book } from '../foundations/icons/object/book';
import { Bookmark } from '../foundations/icons/object/bookmark';
import { Box } from '../foundations/icons/object/box';
import { Briefcase } from '../foundations/icons/object/briefcase';
import { Building } from '../foundations/icons/object/building';
import { Campfire } from '../foundations/icons/object/campfire';
import { Clock } from '../foundations/icons/object/clock';
import { CoffeeMug } from '../foundations/icons/object/coffee-mug';
import { Compass } from '../foundations/icons/object/compass';
import { CreditCard } from '../foundations/icons/object/credit-card';
import { Direction } from '../foundations/icons/object/direction';
import { Directory } from '../foundations/icons/object/directory';
import { Dumbbell } from '../foundations/icons/object/dumbbell';
import { Eye } from '../foundations/icons/object/eye';
import { Flag } from '../foundations/icons/object/flag';
import { Gravestone } from '../foundations/icons/object/gravestone';
import { Headset } from '../foundations/icons/object/headset';
import { Heart } from '../foundations/icons/object/heart';
import { HeartRate } from '../foundations/icons/object/heart-rate';
import { Home } from '../foundations/icons/object/home';
import { HourGlass } from '../foundations/icons/object/hour-glass';
import { Id } from '../foundations/icons/object/id';
import { Image } from '../foundations/icons/object/image';
import { Key } from '../foundations/icons/object/key';
import { Keyhole } from '../foundations/icons/object/keyhole';
import { Lamp } from '../foundations/icons/object/lamp';
import { Leaf } from '../foundations/icons/object/leaf';
import { Lego } from '../foundations/icons/object/lego';
import { Lifebouy } from '../foundations/icons/object/lifebouy';
import { Localization } from '../foundations/icons/object/localization';
import { LocationPin } from '../foundations/icons/object/location-pin';
import { Lock } from '../foundations/icons/object/lock';
import { LockPassword } from '../foundations/icons/object/lock-password';
import { MagicWand } from '../foundations/icons/object/magic-wand';
import { MagnifyingGlass } from '../foundations/icons/object/magnifying-glass';
import { Mailbox } from '../foundations/icons/object/mailbox';
import { Medic } from '../foundations/icons/object/medic';
import { Megaphone } from '../foundations/icons/object/megaphone';
import { OneUp } from '../foundations/icons/object/one-up';
import { PaperPlane } from '../foundations/icons/object/paper-plane';
import { PartyPopper } from '../foundations/icons/object/party-popper';
import { Pencil } from '../foundations/icons/object/pencil';
import { PencilWriting } from '../foundations/icons/object/pencil-writing';
import { PendantLamp } from '../foundations/icons/object/pendant-lamp';
import { Pin } from '../foundations/icons/object/pin';
import { PuzzlePiece } from '../foundations/icons/object/puzzle-piece';
import { Radar } from '../foundations/icons/object/radar';
import { RadarDashboard } from '../foundations/icons/object/radar-dashboard';
import { Rocket } from '../foundations/icons/object/rocket';
import { SecurityCheckmark } from '../foundations/icons/object/security-checkmark';
import { SecurityGear } from '../foundations/icons/object/security-gear';
import { ShoppingBag } from '../foundations/icons/object/shopping-bag';
import { ShoppingCart } from '../foundations/icons/object/shopping-cart';
import { Skull } from '../foundations/icons/object/skull';
import { Speedometer } from '../foundations/icons/object/speedometer';
import { Spinner } from '../foundations/icons/object/spinner';
import { Star } from '../foundations/icons/object/star';
import { Stickers } from '../foundations/icons/object/stickers';
import { Stopwatch } from '../foundations/icons/object/stopwatch';
import { Tag } from '../foundations/icons/object/tag';
import { ThumbsUp } from '../foundations/icons/object/thumbs-up';
import { TrafficCone } from '../foundations/icons/object/traffic-cone';
import { TrafficLight } from '../foundations/icons/object/traffic-light';
import { Trash } from '../foundations/icons/object/trash';
import { Trophy } from '../foundations/icons/object/trophy';
import { UpgradeToPaid } from '../foundations/icons/object/upgrade-to-paid';
import { Vault } from '../foundations/icons/object/vault';
import { Video } from '../foundations/icons/object/video';
import { Agile } from '../foundations/icons/software/agile';
import { Android } from '../foundations/icons/software/android';
import { BrowserArrowRight } from '../foundations/icons/software/browser-arrow-right';
import { BrowserTerminal } from '../foundations/icons/software/browser-terminal';
import { BrowserWindow } from '../foundations/icons/software/browser-window';
import { BrowserCode } from '../foundations/icons/software/browser-code';
import { Bug } from '../foundations/icons/software/bug';
import { ButlerAutomation } from '../foundations/icons/software/butler-automation';
import { Cloud } from '../foundations/icons/software/cloud';
import { CloudCheckmark } from '../foundations/icons/software/cloud-checkmark';
import { CloudDownload } from '../foundations/icons/software/cloud-download';
import { CloudEncryption } from '../foundations/icons/software/cloud-encryption';
import { CloudServer } from '../foundations/icons/software/cloud-server';
import { CloudSettings } from '../foundations/icons/software/cloud-settings';
import { Clouds } from '../foundations/icons/software/clouds';
import { CursorArrow } from '../foundations/icons/software/cursor-arrow';
import { CursorHand } from '../foundations/icons/software/cursor-hand';
import { Database } from '../foundations/icons/software/database';
import { DataCenter } from '../foundations/icons/software/data-center';
import { Firewall } from '../foundations/icons/software/firewall';
import { GitBranch } from '../foundations/icons/software/git-branch';
import { GlobeNetwork } from '../foundations/icons/software/globe-network';
import { GlobeNetworkLocation } from '../foundations/icons/software/globe-network-location';
import { KanbanMove } from '../foundations/icons/software/kanban-move';
import { Server } from '../foundations/icons/software/server';
import { Settings } from '../foundations/icons/software/settings';
import { TrelloBoards } from '../foundations/icons/software/trello-boards';
import { TrelloCard } from '../foundations/icons/software/trello-card';
import { TrelloCardFullCover } from '../foundations/icons/software/trello-card-full-cover';
import { TrelloCardRegularCover } from '../foundations/icons/software/trello-card-regular-cover';
import { TrelloCardRepeating } from '../foundations/icons/software/trello-card-repeating';
import { TrelloCardTemplates } from '../foundations/icons/software/trello-card-templates';
import { TrelloCardTextField } from '../foundations/icons/software/trello-card-text-field';
import { TrelloChecklists } from '../foundations/icons/software/trello-checklists';
import { TrelloLabels } from '../foundations/icons/software/trello-labels';
import { TrelloListsHorizontal } from '../foundations/icons/software/trello-lists-horizontal';
import { TrelloListsVertical } from '../foundations/icons/software/trello-lists-vertical';
import { TrelloWorkspaces } from '../foundations/icons/software/trello-workspaces';
import { Vector } from '../foundations/icons/software/vector';
import { Webhook } from '../foundations/icons/software/webhook';
import { Wifi } from '../foundations/icons/software/wifi';
import { Wrench } from '../foundations/icons/object/wrench';
import { GitMerge } from '../foundations/icons/software/git-merge';
import { News } from './icons/content/news';
import { Lightbulb } from './icons/object/lightbulb';
import { CloudUpload } from './icons/software/cloud-upload';

import { css } from '@emotion/react';
import { getColor, ExportableAdgColorTypes } from '../foundations/adg-colors';

const IconNames = [
  'adduser',
  'group',
  'longhair',
  'shorthair',
  'usersettings',
  'arrowleft',
  'arrowright',
  'arrowsleftright',
  'checkmarkcircle',
  'cycle',
  'dollarsigncircle',
  'dollarsign',
  'exclamation',
  'infocircle',
  'info',
  'minus',
  'new',
  'no',
  'plus',
  'questionmarkcircle',
  'questionmark',
  'restartcircle',
  'restart',
  'x',
  'attachment',
  'calendardate',
  'calendar',
  'checklists',
  'checkmark',
  'contentshare',
  'diagramnetwork',
  'diagramorgchart',
  'diagramvenn',
  'email',
  'filter',
  'folder',
  'graphbar',
  'graphline',
  'graphpie',
  'hive',
  'link',
  'list',
  'mappin',
  'map',
  'maximize',
  'message',
  'news',
  'orgchart',
  'pagemultiple',
  'pagerefresh',
  'pagetree',
  'page',
  'process',
  'rss',
  'smileyface',
  'translate',
  'zipfile',
  'zoomin',
  'zoomout',
  'computer',
  'laptop',
  'smartphone',
  'twofactorauth',
  'watch',
  'badge',
  'ball',
  'balloon',
  'beer',
  'binoculars',
  'bold',
  'bomb',
  'book',
  'bookmark',
  'box',
  'briefcase',
  'building',
  'campfire',
  'clock',
  'coffeemug',
  'cogwheel',
  'compass',
  'creditcard',
  'direction',
  'directory',
  'dumbbell',
  'eye',
  'flag',
  'gravestone',
  'headset',
  'heart',
  'heartrate',
  'home',
  'hourglass',
  'id',
  'image',
  'key',
  'keyhole',
  'lamp',
  'leaf',
  'lego',
  'lifebouy',
  'lightbulb',
  'localization',
  'locationpin',
  'lock',
  'lockpassword',
  'magicwand',
  'magnifyingglass',
  'mailbox',
  'medic',
  'megaphone',
  'oneup',
  'paperplane',
  'partypopper',
  'pencil',
  'pencilwriting',
  'pendantlamp',
  'pin',
  'puzzlepiece',
  'radar',
  'radardashboard',
  'rocket',
  'securitycheckmark',
  'securitygear',
  'shoppingbag',
  'shoppingcart',
  'skull',
  'speedometer',
  'spinner',
  'star',
  'stickers',
  'stopwatch',
  'tag',
  'thumbsup',
  'trafficcone',
  'trafficlight',
  'trash',
  'trophy',
  'upgradetopaid',
  'vault',
  'video',
  'wrench',
  'agile',
  'android',
  'browserarrowright',
  'browsercode',
  'browserterminal',
  'browserwindow',
  'bug',
  'butlerautomation',
  'cloud',
  'cloudcheckmark',
  'clouddownload',
  'cloudencryption',
  'cloudserver',
  'cloudsettings',
  'cloudupload',
  'clouds',
  'cursorarrow',
  'cursorhand',
  'datacenter',
  'database',
  'firewall',
  'gitbranch',
  'gitmerge',
  'globenetwork',
  'globenetworklocation',
  'kanbanmove',
  'server',
  'settings',
  'trelloboards',
  'trellocard',
  'trellocardfullcover',
  'trellocardregularcover',
  'trellocardrepeating',
  'trellocardtemplates',
  'trellocardtextfield',
  'trellochecklists',
  'trellolabels',
  'trellolistshorizontal',
  'trellolistsvertical',
  'trelloworkspaces',
  'vector',
  'webhook',
  'wifi'
] as const;

export type IconNameTypes = (typeof IconNames)[number];

export interface IconProps {
  name: IconNameTypes;
  size?: 'xs' | 'small' | 'medium' | 'large';
  color?: ExportableAdgColorTypes;
}

const getIconSize = (size: string | undefined) => {
  switch (size) {
    case 'xs':
      return '24px';
    case 'small':
      return '32px';
    case 'medium':
      return '48px';
    case 'large':
      return '64px';
    default:
      return '48px';
  }
};

export const IconFetcher = (name: string, size?: string) => {
  const iconSize = getIconSize(size);
  switch (name.toLowerCase()) {
    // avatar
    case 'adduser':
      return <AddUser size={iconSize} />;
    case 'group':
      return <Group size={iconSize} />;
    case 'longhair':
      return <LongHair size={iconSize} />;
    case 'shorthair':
      return <ShortHair size={iconSize} />;
    case 'usersettings':
      return <UserSettings size={iconSize} />;

    // basic
    case 'arrowleft':
      return <ArrowLeft size={iconSize} />;
    case 'arrowright':
      return <ArrowRight size={iconSize} />;
    case 'arrowsleftright':
      return <ArrowsLeftRight size={iconSize} />;
    case 'checkmarkcircle':
      return <CheckmarkCircle size={iconSize} />;
    case 'cycle':
      return <Cycle size={iconSize} />;
    case 'dollarsigncircle':
      return <DollarSignCircle size={iconSize} />;
    case 'dollarsign':
      return <DollarSign size={iconSize} />;
    case 'exclamation':
      return <Exclamation size={iconSize} />;
    case 'infocircle':
      return <InfoCircle size={iconSize} />;
    case 'info':
      return <Info size={iconSize} />;
    case 'minus':
      return <Minus size={iconSize} />;
    case 'new':
      return <New size={iconSize} />;
    case 'no':
      return <No size={iconSize} />;
    case 'plus':
      return <Plus size={iconSize} />;
    case 'questionmarkcircle':
      return <QuestionMarkCircle size={iconSize} />;
    case 'questionmark':
      return <QuestionMark size={iconSize} />;
    case 'restartcircle':
      return <RestartCircle size={iconSize} />;
    case 'restart':
      return <Restart size={iconSize} />;
    case 'x':
      return <X size={iconSize} />;

    // content
    case 'attachment':
      return <Attachment size={iconSize} />;
    case 'calendardate':
      return <CalendarDate size={iconSize} />;
    case 'calendar':
      return <Calendar size={iconSize} />;
    case 'checklists':
      return <Checklists size={iconSize} />;
    case 'checkmark':
      return <Checkmark size={iconSize} />;
    case 'contentshare':
      return <ContentShare size={iconSize} />;
    case 'diagramnetwork':
      return <DiagramNetwork size={iconSize} />;
    case 'diagramorgchart':
      return <DiagramOrgChart size={iconSize} />;
    case 'diagramvenn':
      return <DiagramVenn size={iconSize} />;
    case 'email':
      return <Email size={iconSize} />;
    case 'filter':
      return <Filter size={iconSize} />;
    case 'folder':
      return <Folder size={iconSize} />;
    case 'graphbar':
      return <GraphBar size={iconSize} />;
    case 'graphline':
      return <GraphLine size={iconSize} />;
    case 'graphpie':
      return <GraphPie size={iconSize} />;
    case 'hive':
      return <Hive size={iconSize} />;
    case 'link':
      return <Link size={iconSize} />;
    case 'list':
      return <List size={iconSize} />;
    case 'mappin':
      return <MapPin size={iconSize} />;
    case 'map':
      return <Map size={iconSize} />;
    case 'maximize':
      return <Maximize size={iconSize} />;
    case 'message':
      return <Message size={iconSize} />;
    case 'news':
      return <News size={iconSize} />;
    case 'orgchart':
      return <OrgChart size={iconSize} />;
    case 'pagemultiple':
      return <PageMultiple size={iconSize} />;
    case 'pagerefresh':
      return <PageRefresh size={iconSize} />;
    case 'pagetree':
      return <PageTree size={iconSize} />;
    case 'page':
      return <Page size={iconSize} />;
    case 'process':
      return <Process size={iconSize} />;
    case 'rss':
      return <Rss size={iconSize} />;
    case 'smileyface':
      return <SmileyFace size={iconSize} />;
    case 'translate':
      return <Translate size={iconSize} />;
    case 'zipfile':
      return <ZipFile size={iconSize} />;
    case 'zoomin':
      return <ZoomIn size={iconSize} />;
    case 'zoomout':
      return <ZoomOut size={iconSize} />;

    // device
    case 'computer':
      return <Computer size={iconSize} />;
    case 'laptop':
      return <Laptop size={iconSize} />;
    case 'smartphone':
      return <Smartphone size={iconSize} />;
    case 'twofactorauth':
      return <TwoFactorAuth size={iconSize} />;
    case 'watch':
      return <Watch size={iconSize} />;

    // object
    case 'badge':
      return <Badge size={iconSize} />;
    case 'ball':
      return <Ball size={iconSize} />;
    case 'balloon':
      return <Balloon size={iconSize} />;
    case 'beer':
      return <Beer size={iconSize} />;
    case 'binoculars':
      return <Binoculars size={iconSize} />;
    case 'bold':
      return <Bold size={iconSize} />;
    case 'bomb':
      return <Bomb size={iconSize} />;
    case 'book':
      return <Book size={iconSize} />;
    case 'bookmark':
      return <Bookmark size={iconSize} />;
    case 'box':
      return <Box size={iconSize} />;
    case 'briefcase':
      return <Briefcase size={iconSize} />;
    case 'building':
      return <Building size={iconSize} />;
    case 'campfire':
      return <Campfire size={iconSize} />;
    case 'clock':
      return <Clock size={iconSize} />;
    case 'coffeemug':
      return <CoffeeMug size={iconSize} />;
    case 'cogwheel':
      return <CoffeeMug size={iconSize} />;
    case 'compass':
      return <Compass size={iconSize} />;
    case 'creditcard':
      return <CreditCard size={iconSize} />;
    case 'direction':
      return <Direction size={iconSize} />;
    case 'directory':
      return <Directory size={iconSize} />;
    case 'dumbbell':
      return <Dumbbell size={iconSize} />;
    case 'eye':
      return <Eye size={iconSize} />;
    case 'flag':
      return <Flag size={iconSize} />;
    case 'gravestone':
      return <Gravestone size={iconSize} />;
    case 'headset':
      return <Headset size={iconSize} />;
    case 'heart':
      return <Heart size={iconSize} />;
    case 'heartrate':
      return <HeartRate size={iconSize} />;
    case 'home':
      return <Home size={iconSize} />;
    case 'hourglass':
      return <HourGlass size={iconSize} />;
    case 'id':
      return <Id size={iconSize} />;
    case 'image':
      return <Image size={iconSize} />;
    case 'key':
      return <Key size={iconSize} />;
    case 'keyhole':
      return <Keyhole size={iconSize} />;
    case 'lamp':
      return <Lamp size={iconSize} />;
    case 'leaf':
      return <Leaf size={iconSize} />;
    case 'lego':
      return <Lego size={iconSize} />;
    case 'lifebouy':
      return <Lifebouy size={iconSize} />;
    case 'lightbulb':
      return <Lightbulb size={iconSize} />;
    case 'localization':
      return <Localization size={iconSize} />;
    case 'locationpin':
      return <LocationPin size={iconSize} />;
    case 'lock':
      return <Lock size={iconSize} />;
    case 'lockpassword':
      return <LockPassword size={iconSize} />;
    case 'magicwand':
      return <MagicWand size={iconSize} />;
    case 'magnifyingglass':
      return <MagnifyingGlass size={iconSize} />;
    case 'mailbox':
      return <Mailbox size={iconSize} />;
    case 'medic':
      return <Medic size={iconSize} />;
    case 'megaphone':
      return <Megaphone size={iconSize} />;
    case 'oneup':
      return <OneUp size={iconSize} />;
    case 'paperplane':
      return <PaperPlane size={iconSize} />;
    case 'partypopper':
      return <PartyPopper size={iconSize} />;
    case 'pencil':
      return <Pencil size={iconSize} />;
    case 'pencilwriting':
      return <PencilWriting size={iconSize} />;
    case 'pendantlamp':
      return <PendantLamp size={iconSize} />;
    case 'pin':
      return <Pin size={iconSize} />;
    case 'puzzlepiece':
      return <PuzzlePiece size={iconSize} />;
    case 'radar':
      return <Radar size={iconSize} />;
    case 'radardashboard':
      return <RadarDashboard size={iconSize} />;
    case 'rocket':
      return <Rocket size={iconSize} />;
    case 'securitycheckmark':
      return <SecurityCheckmark size={iconSize} />;
    case 'securitygear':
      return <SecurityGear size={iconSize} />;
    case 'shoppingbag':
      return <ShoppingBag size={iconSize} />;
    case 'shoppingcart':
      return <ShoppingCart size={iconSize} />;
    case 'skull':
      return <Skull size={iconSize} />;
    case 'speedometer':
      return <Speedometer size={iconSize} />;
    case 'spinner':
      return <Spinner size={iconSize} />;
    case 'star':
      return <Star size={iconSize} />;
    case 'stickers':
      return <Stickers size={iconSize} />;
    case 'stopwatch':
      return <Stopwatch size={iconSize} />;
    case 'tag':
      return <Tag size={iconSize} />;
    case 'thumbsup':
      return <ThumbsUp size={iconSize} />;
    case 'trafficcone':
      return <TrafficCone size={iconSize} />;
    case 'trafficlight':
      return <TrafficLight size={iconSize} />;
    case 'trash':
      return <Trash size={iconSize} />;
    case 'trophy':
      return <Trophy size={iconSize} />;
    case 'upgradetopaid':
      return <UpgradeToPaid size={iconSize} />;
    case 'vault':
      return <Vault size={iconSize} />;
    case 'video':
      return <Video size={iconSize} />;
    case 'wrench':
      return <Wrench size={iconSize} />;

    // software
    case 'agile':
      return <Agile size={iconSize} />;
    case 'android':
      return <Android size={iconSize} />;
    case 'browserarrowright':
      return <BrowserArrowRight size={iconSize} />;
    case 'browsercode':
      return <BrowserCode size={iconSize} />;
    case 'browserterminal':
      return <BrowserTerminal size={iconSize} />;
    case 'browserwindow':
      return <BrowserWindow size={iconSize} />;
    case 'bug':
      return <Bug size={iconSize} />;
    case 'butlerautomation':
      return <ButlerAutomation size={iconSize} />;
    case 'cloud':
      return <Cloud size={iconSize} />;
    case 'cloudcheckmark':
      return <CloudCheckmark size={iconSize} />;
    case 'clouddownload':
      return <CloudDownload size={iconSize} />;
    case 'cloudencryption':
      return <CloudEncryption size={iconSize} />;
    case 'cloudserver':
      return <CloudServer size={iconSize} />;
    case 'cloudsettings':
      return <CloudSettings size={iconSize} />;
    case 'cloudupload':
      return <CloudUpload size={iconSize} />;
    case 'clouds':
      return <Clouds size={iconSize} />;
    case 'cursorarrow':
      return <CursorArrow size={iconSize} />;
    case 'cursorhand':
      return <CursorHand size={iconSize} />;
    case 'datacenter':
      return <DataCenter size={iconSize} />;
    case 'database':
      return <Database size={iconSize} />;
    case 'firewall':
      return <Firewall size={iconSize} />;
    case 'gitbranch':
      return <GitBranch size={iconSize} />;
    case 'gitmerge':
      return <GitMerge size={iconSize} />;
    case 'globenetwork':
      return <GlobeNetwork size={iconSize} />;
    case 'globenetworklocation':
      return <GlobeNetworkLocation size={iconSize} />;
    case 'kanbanmove':
      return <KanbanMove size={iconSize} />;
    case 'server':
      return <Server size={iconSize} />;
    case 'settings':
      return <Settings size={iconSize} />;
    case 'trelloboards':
      return <TrelloBoards size={iconSize} />;
    case 'trellocard':
      return <TrelloCard size={iconSize} />;
    case 'trellocardfullcover':
      return <TrelloCardFullCover size={iconSize} />;
    case 'trellocardregularcover':
      return <TrelloCardRegularCover size={iconSize} />;
    case 'trellocardrepeating':
      return <TrelloCardRepeating size={iconSize} />;
    case 'trellocardtemplates':
      return <TrelloCardTemplates size={iconSize} />;
    case 'trellocardtextfield':
      return <TrelloCardTextField size={iconSize} />;
    case 'trellochecklists':
      return <TrelloChecklists size={iconSize} />;
    case 'trellolabels':
      return <TrelloLabels size={iconSize} />;
    case 'trellolistshorizontal':
      return <TrelloListsHorizontal size={iconSize} />;
    case 'trellolistsvertical':
      return <TrelloListsVertical size={iconSize} />;
    case 'trelloworkspaces':
      return <TrelloWorkspaces size={iconSize} />;
    case 'vector':
      return <Vector size={iconSize} />;
    case 'webhook':
      return <Webhook size={iconSize} />;
    case 'wifi':
      return <Wifi size={iconSize} />;
    default:
      return null;
  }
};

export const Icon = ({ name, size, color }: IconProps) => {
  const iconColor = color ? getColor(color) : getColor('n900');
  return (
    <div
      className="icon"
      css={css`
        color: ${iconColor};
        line-height: 0;
      `}
    >
      {IconFetcher(name, size)}
    </div>
  );
};
